export default __webpack_public_path__ + "static/media/mobile_close.b70c24fb.svg";